import { Card } from "antd";

interface IWidgetCard {
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    overwriteDefaultClass?: boolean;
    bodyPaddingClass?: string;
    bodyStyle?: React.CSSProperties;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
}
const WidgetCard: React.FC<IWidgetCard> = ({
    children,
    className,
    style,
    overwriteDefaultClass = false,
    bodyPaddingClass,
    bodyStyle,
    onMouseEnter = () => { },
    onMouseLeave = () => { },
}) => {
    return (
        <Card
            className={
                overwriteDefaultClass
                    ? className
                    : `shadow-sm border rounded-4 ${className}`
            }
            style={style}
            bordered
            classNames={{
                body: bodyPaddingClass,
            }}
            styles={{
                body: bodyStyle,
            }}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            {children}
        </Card>
    );
};

export default WidgetCard;
